import React, { useState } from 'react';

export function participantIdentity(participant) {
  let data = {};
  try { data = JSON.parse(participant.metadata || '{}') || {}; } catch { /* legacy participant */ }
  const avatar = typeof data.avatar_url === 'string' && /^\/api\/meetings\/public\/photos\/bk_[a-f0-9]{16,32}\/(host|guest)\?token=[A-Za-z0-9._%-]+$/.test(data.avatar_url) ? data.avatar_url : '';
  return { name: participant.name || 'Participante', jobTitle: typeof data.job_title === 'string' ? data.job_title.slice(0,80) : '', avatar };
}

export default function MeetingIdentity({ viewer, youLabel }) {
  const [failed, setFailed] = useState('');
  return <>
    <div className="mr-audience__avatar" aria-hidden="true">
      {viewer.avatar && failed !== viewer.avatar ? <img src={viewer.avatar} alt="" referrerPolicy="no-referrer" onError={() => setFailed(viewer.avatar)} style={{width:'100%',height:'100%',objectFit:'cover'}} /> : (viewer.name || '?').charAt(0).toUpperCase()}
    </div>
    <div className="min-w-0 flex-1">
      <p className="mr-audience__name">{viewer.name}{viewer.isLocal && <span className="mr-audience__you">{youLabel}</span>}</p>
      {viewer.jobTitle && <p className="mr-audience__meta">{viewer.jobTitle}</p>}
      <p className="mr-audience__meta">{viewer.deviceLabel}</p>
    </div>
  </>;
}
